// components
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { range } from "remeda";

enum OperationRecordType {
  editSetting,
  applyDeposit,
  collect,
  applyWithdraw,
  revokeSlip,
  executeWithdraw,
}

const OperationRecordTypeText = Object.freeze({
  [OperationRecordType.editSetting]: "修改設定",
  [OperationRecordType.applyDeposit]: "申請打款",
  [OperationRecordType.collect]: "歸集",
  [OperationRecordType.applyWithdraw]: "申請下發",
  [OperationRecordType.revokeSlip]: "撤回訂單",
  [OperationRecordType.executeWithdraw]: "執行下發",
});

interface OperationRecordRead {
  id: string;
  type: OperationRecordType;
  tenant?: {
    id: string;
    name: string;
  };
  member: {
    id: string;
    username: string;
    nickname: string;
  };
  details: string;
  created_at: string;
}

export const TenantManageOperationsPage = () => {
  const columns: ColumnsType<OperationRecordRead> = [
    {
      key: "type",
      width: 160,
      title: "類型",
      render(_, { type }) {
        return OperationRecordTypeText[type];
      },
    },
    {
      width: 164,
      title: "來源",
      key: "source",
      render(_, { tenant }) {
        return tenant ? "-" : "系統";
      },
    },
    {
      width: 164,
      title: "用戶",
      key: "member",
      render(_, { tenant, member }) {
        return tenant ? member.username : "-";
      },
    },
    {
      title: "操作細節",
      dataIndex: "details",
    },
    {
      width: 90,
      align: "right",
      className: "v:top px:6!:is(td)",
      title: "操作時間",
      dataIndex: "created_at",
      sorter: () => 1,
    },
  ];

  const operationRecords = range(1, 30).map<OperationRecordRead>((n) => {
    const type = n % 6;

    const tenant =
      type > OperationRecordType.applyWithdraw
        ? undefined
        : {
            id: n.toString(),
            name: "TACO168",
          };

    return {
      id: n.toString(),
      type,
      tenant,
      member: {
        id: n.toString(),
        username: "ys00t123",
        nickname: "ys00t123",
      },
      details: "",
      created_at: "2023-08-01 12:00:00",
    };
  });

  return (
    <div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={operationRecords}
      ></Table>
    </div>
  );
};
